export function htmlElements(): {
    form: HTMLFormElement
    dgLoader: HTMLDivElement
    succcessMessage: HTMLParagraphElement
    termCheckbox: HTMLInputElement
    accountNumber: string
    routingNumber: string
    tabContents: HTMLCollectionOf<HTMLElement>
    tabLinks: HTMLCollectionOf<HTMLButtonElement>
    discountElements: NodeListOf<Element>
    summaryTargetElement: HTMLElement
    appliancesTargetElement: HTMLElement
    submitButton: HTMLButtonElement
    accountNumberError: HTMLParagraphElement
    routingNumberError: HTMLParagraphElement
    termsAndConditionsError: HTMLParagraphElement
    cardNumberError: HTMLParagraphElement
    expiryDateError: HTMLParagraphElement
    CVVError: HTMLParagraphElement
    errorMessages: NodeListOf<HTMLParagraphElement>
    basePrices: NodeListOf<HTMLElement>
    achPrices: NodeListOf<HTMLElement>
    discountDetails: NodeListOf<HTMLElement>
    formInputs: NodeListOf<HTMLElement>
    tab: (tabName: string) => HTMLElement
    tabContent: (tabName: string) => HTMLElement
} {
    const form = document.getElementById('gc-dg-paymentForm') as HTMLFormElement
    const dgLoader = document.getElementById('gc-dg-Loader') as HTMLDivElement
    const succcessMessage = document.getElementById(
        'gc-dg-successMessage',
    ) as HTMLParagraphElement
    const termCheckbox = document.getElementById(
        'gc-dg-tandc',
    ) as HTMLInputElement
    const accountNumber = (
        document.getElementById('gc-dg-accountNumber') as HTMLInputElement
    )?.value
    const routingNumber = (
        document.getElementById('gc-dg-routingNumber') as HTMLInputElement
    )?.value
    const tabContents = document.getElementsByClassName(
        'gc-dg-tab-content',
    ) as HTMLCollectionOf<HTMLElement>
    const tabLinks = document.getElementsByClassName(
        'gc-dg-tab-link',
    ) as HTMLCollectionOf<HTMLButtonElement>

    const discountElements = document.querySelectorAll('.gc-dg-discount')

    const summaryTargetElement = document.getElementById(
        'gc-dg-summary',
    ) as HTMLElement

    const appliancesTargetElement = document.getElementById(
        'gc-dg-appliances',
    ) as HTMLElement

    const submitButton = document.getElementById(
        'gc-dg-payNow',
    ) as HTMLButtonElement

    const accountNumberError = document.getElementById(
        'gc-dg-accountNumberError',
    ) as HTMLParagraphElement

    const routingNumberError = document.getElementById(
        'gc-dg-routingNumberError',
    ) as HTMLParagraphElement

    const termsAndConditionsError = document.getElementById(
        'gc-dg-termsAndConditionsError',
    ) as HTMLParagraphElement

    const cardNumberError = document.getElementById(
        'gc-dg-card-number-error',
    ) as HTMLParagraphElement

    const expiryDateError = document.getElementById(
        'gc-dg-expiry-date-error',
    ) as HTMLParagraphElement

    const CVVError = document.getElementById(
        'gc-dg-cvv-error',
    ) as HTMLParagraphElement

    const errorMessages = document.querySelectorAll(
        '.gc-dg-error-message:not(.gc-dg-hidden)',
    )

    const basePrices = document.querySelectorAll('.gc-dg-base-price')

    const achPriceElements = document.querySelectorAll('.gc-dg-ach-price')

    const discountDetails = document.querySelectorAll('.gc-dg-discount-details')

    const formInputs = document.querySelectorAll(
        '.gc-dg-input, .gc-dg-checkbox-input ',
    )

    const tab = (tabName: string): HTMLElement => {
        return document.getElementById(`gc-dg-${tabName}-tab`) as HTMLElement
    }

    const tabContent = (tabName: string): HTMLElement => {
        return document.getElementById(`gc-dg-${tabName}`) as HTMLElement
    }

    return {
        form,
        dgLoader,
        succcessMessage,
        termCheckbox,
        accountNumber,
        routingNumber,
        tabContents,
        tabLinks,
        discountElements,
        summaryTargetElement,
        appliancesTargetElement,
        submitButton,
        accountNumberError,
        routingNumberError,
        termsAndConditionsError,
        cardNumberError,
        expiryDateError,
        CVVError,
        errorMessages: errorMessages as NodeListOf<HTMLParagraphElement>,
        basePrices: basePrices as NodeListOf<HTMLElement>,
        achPrices: achPriceElements as NodeListOf<HTMLElement>,
        discountDetails: discountDetails as NodeListOf<HTMLElement>,
        formInputs: formInputs as NodeListOf<HTMLElement>,
        tab,
        tabContent,
    }
}
